import { render, staticRenderFns } from "./ModalHomeBoxCreateEdit.vue?vue&type=template&id=e47a2750&scoped=true&"
import script from "./ModalHomeBoxCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ModalHomeBoxCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalHomeBoxCreateEdit.vue?vue&type=style&index=0&id=e47a2750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47a2750",
  null
  
)

export default component.exports